/**
 * Helper function for react-final-form validators
 * @param validators
 */
export const composeValidators =
    (...validators: any[]) =>
    (value: any) =>
        validators.reduce(
            (error, validator) => error || validator(value),
            undefined
        );

/**
 * Check for a required value
 * @param value
 */
export const required = (value: any) => (value ? undefined : 'Required');

/**
 * Check for a valid Name
 * @param value
 */
export const mustBeName = (value: string) => {
    const regex = new RegExp(/^[a-z -]+$/i);
    return regex.test(value)
        ? undefined
        : 'Names can only contain letters, spaces and dashes';
};
